// extracted by mini-css-extract-plugin
export default {"fullSize":"full-size__Uw6nSVug"};